import React from 'react'

const DynamicMessage = ({ template, variables, className = 'selectLabel p-3' }) => {
  const renderMessage = (template, vars) => {
    let message = template
    Object.keys(vars).forEach((key) => {
      message = message.replace(`[${key}]`, vars[key])
    })
    return message
  }

  return <strong className={className}>{renderMessage(template, variables)}</strong>
}

export default DynamicMessage
